import { Component, OnInit, inject } from '@angular/core';
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import { DatePipe, NgOptimizedImage } from "@angular/common";
import {ReactiveFormsModule} from "@angular/forms";
import {LocaleService} from "../../../../locale/locale.service";
import {ClaimsService} from "../../../../services/claims.service";
import {UserType} from "../../../../enums/user-type";
import {IncidentType} from "../../../../enums/incident-type";
import {InvolvedVehicleType} from "../../../../enums/involved-vehicle-type";
import {RouterLink} from "@angular/router";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {RideReason} from "../../../../enums/ride-reason";
import {WhoIsAtFault} from "../../../../enums/who-is-at-fault";
import {ImageComponent} from "../../../common/image/image.component";
import {VerificationService} from "../../../../services/verification.service";

@Component({
  selector: 'app-overview',
  imports: [
    FooterComponent,
    HeaderComponent,
    ReactiveFormsModule,
    NgOptimizedImage,
    DatePipe,
    RouterLink,
    ImageComponent
],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.css'
})
export class OverviewComponent implements OnInit {
  locale = inject(LocaleService);
  claimService = inject(ClaimsService);
  private formNavigationService = inject(FormNavigationService);
  private verificationService = inject(VerificationService);


  ngOnInit(): void {
    this.claimService.getData().subscribe(() => {
    })
  }

  nextClicked() {
    this.formNavigationService.navigate(NavigationKey['overview']);
  }

  mapUserType() {
    switch (this.claimService.claimReport().userType) {
      case UserType.FirstParty:
        return this.locale.currentTranslation.userParticipationIdentificationOptionHeadline1
      case UserType.ThirdParty:
        return this.locale.currentTranslation.userParticipationIdentificationOptionHeadline2
      default:
        return ""
    }
  }

  mapDamageType() {
    let incidentTypes = '';
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.FailureToYield)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline1 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.ParkedVehicleCollision)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline2 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.NoOtherVehicleInvolved)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline3 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.RearEndCollision)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline4 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.OncomingTrafficCollision)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline5 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.SideSwipe)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline6 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.LaneChangeIncident)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline7 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.ParkingIncident)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline8 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.NoContact)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline9 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.TippedOverEScooter)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline10 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.Other)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline11 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.PersonalDamagedItem)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline12 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.OtherPropertyDamage)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline13 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.AnimalInjury)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline14 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.InjuredPerson)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline15 + ' ';
    }
    if (this.claimService?.claimReport()?.incidentTypes?.includes(IncidentType.InjuryWhileAvoiding)) {
      incidentTypes += this.locale.currentTranslation.incidentDescriptionOptionHeadline16 + ' ';
    }
    return incidentTypes;
  }

  mapInvolvedVehicles() {
    switch (this.claimService.claimReport().vehicleType) {
      case InvolvedVehicleType.FourWheelsWithEngine:
        return this.locale.currentTranslation.vehicleInvolvedOptionHeadline1
      case InvolvedVehicleType.TwoWheelsWithEngine:
        return this.locale.currentTranslation.vehicleInvolvedOptionHeadline2
      case InvolvedVehicleType.TwoWheelsWithNoEngine:
        return this.locale.currentTranslation.vehicleInvolvedOptionHeadline3
      case InvolvedVehicleType.None:
        return this.locale.currentTranslation.vehicleInvolvedOptionHeadline4

      default:
        return ""
    }
  }

  mapRideReason() {
    switch (this.claimService.claimReport().rideReason) {
      case RideReason.PrivateTrip:
        return this.locale.currentTranslation.rideReasonOptionHeadline1
      case RideReason.BusinessTrip:
        return this.locale.currentTranslation.rideReasonOptionHeadline2
      case RideReason.Commute:
        return this.locale.currentTranslation.rideReasonOptionHeadline3
      default:
        return ""
    }
  }

  mapBoolean(policeDrugTestPerformed: boolean | null) {

    return policeDrugTestPerformed ? this.locale.currentTranslation.yes : this.locale.currentTranslation.no;
  }

  mapFault() {
    switch (this.claimService.claimReport().fault) {
      case WhoIsAtFault.Both:
        return this.locale.currentTranslation.faultAllocationOptionHeadline1
      case WhoIsAtFault.ThirdParty:
        return this.claimService.isDriver() ? this.locale.currentTranslation.faultAllocationOptionHeadline2 : this.locale.currentTranslation.thirdPartyFaultAllocationOptionHeadline2
      case WhoIsAtFault.FirstParty:
        return this.claimService.isDriver() ? this.locale.currentTranslation.faultAllocationOptionHeadline3 : this.locale.currentTranslation.thirdPartyFaultAllocationOptionHeadline3
      case WhoIsAtFault.Unknown:
        return this.locale.currentTranslation.faultAllocationOptionHeadline4
      default:
        return "";
    }

  }

  mapPreferredContactMethod() {
    if (this.claimService.claimReport().personalInformation?.contactableBySms && this.claimService.claimReport().personalInformation?.contactableByEmail) {
      return this.locale.currentTranslation.sms + ' ' + this.locale.currentTranslation.and + ' ' + this.locale.currentTranslation.email;
    } else {
      if (this.claimService.claimReport().personalInformation?.contactableBySms) {
        return this.locale.currentTranslation.sms;
      }
      if (this.claimService.claimReport().personalInformation?.contactableByEmail) {
        return this.locale.currentTranslation.email;
      }
    }
    return "";
  }
}
